import { createApp } from 'vue'
import VueDOMPurifyHTML from 'vue-dompurify-html';
import AppComponent from './App.vue'
import router, { createHttpGuard } from './router/index'
import 'element-plus/dist/index.css'
import './styles/index.less'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { setupStore } from '@/store'
import { setupI18n } from './i18n'
import { customEvent } from './utils/utils'
import { handleInitVConsole } from '@/utils/handleVConsole'
import { setUpElement } from '@/plugin/element-plus'
import loadingDirective from '@/components/Loading/loading'
import customEventDirective from '@/components/CustomEventData/customEvent'
import { debounceClickHook } from '@/hooks/useDebouncedHook'
// import AntiDebug from '@/utils/antiDebug'

// 初始化反调试工具 todo 下个版本开启
// if (process.env.BASE_ENV === 'cn_mall' || process.env.BASE_ENV === 'global_mall') {
//   const antiDebug = new AntiDebug({
//     disableDevTools: true,
//     disableRightClick: true,
//     disableF12: true,
//     disableSelection: false,
//     disableCopy: false,
//     checkDebuggerInterval: 1000,
//     onDetected: () => {
//       console.log('检测到调试行为，已禁用部分功能')
//       // 可以在这里添加额外的处理逻辑，如上报或清除敏感数据
//     }
//   })
//   antiDebug.init()
// }

handleInitVConsole()
createHttpGuard(router)

// 自动引入所有的 SVG 图标
const requireAll = (requireContext: any) => requireContext.keys().map(requireContext)
// @ts-ignore
const req = require.context('./assets/icons/svg', false, /\.svg$/)
requireAll(req)


const app = createApp(AppComponent)

app.config.globalProperties.$customEvent = customEvent
app.directive('cusLoading', loadingDirective)
app.directive('customEvent', customEventDirective)
app.directive('debounce', debounceClickHook);
app.use(router)
app.use(VueDOMPurifyHTML)

setupStore(app)
setupI18n(app)
setUpElement(app)
app.mount('#app')

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('./serviceWorker.js')
    .then(() => console.log('Service Worker 注册成功'))
    .catch(err => console.log('注册失败:', err));
}
